export default "__VITE_ASSET__Bfb5CUeK__"